import { styled, component } from '../../../../utils/style';

export const DriveItemListSearchButtonContainer = styled()(component.div, 'DriveItemListSearchButtonContainer')`
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
`;

export const StyledDriveItemListSearchButton = styled()(component.button, 'StyledDriveItemListSearchButton')`
	cursor: pointer;
	border-color: transparent;
	background-color: transparent;
	height: 36px;
	width: 36px;
	padding: 0;
	box-sizing: border-box;
	transition: .1s ease-in-out;
	transition-property: opacity, border-color;

	&:focus {
		outline: 0;
	}

	& > svg {
		height: 30px;
		width: 30px;
		fill: ${props => props.theme.primary.iconsColor};
	}

	&:active {
		opacity: 0.3;
	}
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemList/Search/Button/styles.ts